import supportConfig from '../../../../config/whatsappSupport.json'

export const waUrlBuilder = (): string => {
    return `${supportConfig.whatsappUrl}/${supportConfig.PhoneNumber}?text=${supportConfig.PredefinedMessage}`;
}